import { render, staticRenderFns } from "./BrandTutorialVideos.vue?vue&type=template&id=e29462cc&scoped=true&"
import script from "./BrandTutorialVideos.vue?vue&type=script&lang=ts&"
export * from "./BrandTutorialVideos.vue?vue&type=script&lang=ts&"
import style0 from "./BrandTutorialVideos.vue?vue&type=style&index=0&id=e29462cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e29462cc",
  null
  
)

export default component.exports